import {TranslatedKeys} from 'shared/types/translated-keys';

export interface LogProps {
  userId: string;
  url: string;
  method: string;
  statusCode: number;
  duration: number;
  request: any;
  headers: any;
  response: any;
  createdAt: Date;
}

export const translatedLogProps: TranslatedKeys<LogProps> = {
  userId: 'Usuário',
  url: 'Url',
  method: 'Método',
  statusCode: 'Status',
  duration: 'Duração',
  request: 'Requisição',
  headers: 'Cabeçalho',
  response: 'Resposta',
  createdAt: 'Data',
};
